import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { RatioOptions, TextStyleOptions } from '@df/ui/atomic/atomic-options';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';

export namespace NCmsImage {
    export const componentId = 'image-quote';

    export interface IComponentData extends NICmsContentComponent.IData {
        columns: IColumn[];
    }

    interface IColumn {
        variant: 'image' | 'quote';
        url?: string;
        image?: string;
        ratio?: string;
        quote?: string;
        quote_font_style: string;
        caption?: string;
        caption_align?: 'left' | 'right';
    }
}

@Component({
    selector: 'cms-image-quote',
    templateUrl: 'cms-image-quote.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<CmsImageQuoteComponent>({
    id: NCmsImage.componentId,
    name: 'Image and Quote',
    description: '50/50 Image Quote',
    fields: [
        <NICmsContentField.IRepeaterField>{
            key: 'columns',
            title: 'Columns',
            type: NICmsContentField.EFieldType.repeater,
            itemName: 'Column',
            fields: [
                <NICmsContentField.IChoiceField>{
                    type: NICmsContentField.EFieldType.choice,
                    key: 'variant',
                    title: 'Variant',
                    default: 'image',
                    options: [
                        {
                            key: 'image',
                            title: 'Image'
                        },
                        {
                            key: 'quote',
                            title: 'Quote'
                        }
                    ]
                },
                {
                    key: 'image',
                    title: 'Image Upload',
                    type: NICmsContentField.EFieldType.image,
                    default: '/cms/media/default.svg',
                    canShow: data => data.variant === 'image'
                },
                <NICmsContentField.IChoiceField>{
                    key: 'ratio',
                    type: NICmsContentField.EFieldType.choice,
                    title: 'Ratio',
                    options: RatioOptions,
                    default: 'ratio-1-1',
                    canShow: data => data.variant === 'image'
                },
                {
                    key: 'url',
                    title: 'Link',
                    type: NICmsContentField.EFieldType.text,
                    canShow: data => data.variant === 'image'
                },
                {
                    key: 'quote',
                    title: 'Quote',
                    type: NICmsContentField.EFieldType.textarea,
                    canShow: data => data.variant === 'quote'
                },
                <NICmsContentField.IChoiceField>{
                    key: 'quote_font_style',
                    type: NICmsContentField.EFieldType.choice,
                    title: 'Quote Font Style',
                    options: TextStyleOptions,
                    default: 'o1',
                    canShow: data => data.variant === 'quote'
                },
                {
                    key: 'caption',
                    title: 'Caption',
                    type: NICmsContentField.EFieldType.text
                },
                <NICmsContentField.IChoiceField>{
                    type: NICmsContentField.EFieldType.choice,
                    key: 'caption_align',
                    title: 'Caption alignment',
                    default: 'left',
                    options: [
                        {
                            key: 'left',
                            title: 'Left'
                        },
                        {
                            key: 'right',
                            title: 'Right'
                        }
                    ],
                    canShow: data => data.variant === 'image'
                }
            ],
            defaultSize: 2,
            maxSize: 2,
            default: [
                {
                    variant: 'quote',
                    quote_font_style: 'o1',
                    caption: 'Caption',
                    quote: '`Quote fo image`'
                },
                {
                    variant: 'image',
                    image: '/cms/media/default.svg',
                    ratio: 'ratio-1-1'
                }
            ]
        }
    ]
})
export class CmsImageQuoteComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component?: NCmsImage.IComponentData;
}
